import { SOLIDGATE_FORM_CONFIG } from '@feature/payment/solidgate/config/solidgate.form.config';
import { type InitConfig, FormType } from '@solidgate/react-sdk';
import { useSolidgateConditions } from '@feature/payment/solidgate/hooks/useSolidgateConditions';

type FormConfig = Omit<InitConfig, 'merchantData' | 'iframeParams' | 'paypalButtonParams'> & { width: string };

/**
 * Hook to get the Solidgate form configuration.
 * It adjusts the form type based on whether the card form can be rendered.
 * @see SOLIDGATE_FORM_CONFIG - config
 */
export const useSolidgateFormConfig = (): FormConfig => {
  const { canRenderFormCard } = useSolidgateConditions();
  const formTypeClass = canRenderFormCard ? FormType.Card : FormType.Default;
  const { formParams, ...mainConfig } = SOLIDGATE_FORM_CONFIG;

  return { formParams: { ...formParams, formTypeClass }, width: '100%', ...mainConfig };
};
